import { render, staticRenderFns } from "./productionConfiguration.vue?vue&type=template&id=5920ba30&"
import script from "./productionConfiguration.vue?vue&type=script&lang=js&"
export * from "./productionConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports